import axios from 'axios';

export function toggleOverlay(status) {
  const overlay = document.querySelector('#ProductGridContainer [data-loading]');
  overlay?.classList.toggle('hidden', !status);
}

export async function getLocationData() {
  const storesResp = await fetch("https://intersportapi.netlify.app/.netlify/functions/getStores")
  const apiLocations = await storesResp.json();
  const locations = [...apiLocations];
  return locations;
}

export async function sendAPIRequest(endpoint, body, RELEWISE_API_KEY) {
  try {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': RELEWISE_API_KEY,
      },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    return data;
  } catch (error) {
    console.error('[SEARCH] Failed to fetch results', error);
    return [];
  }
}

export function getFacet(name, searchResultData) {
  name = name.replace('filter-', '');
  let resultFacet;
  searchResultData?.facets?.items.forEach(facet => {
    if (facet.$type === "Relewise.Client.DataTypes.Search.Facets.Result.ProductDataStringValueFacetResult, Relewise.Client" || facet.$type === "Relewise.Client.DataTypes.Search.Facets.Result.VariantSpecificationFacetResult, Relewise.Client") {
      if (name.toLowerCase() === facet.key.toLowerCase()) {
        resultFacet = facet;
      } else if ("intersport-dk.myshopify.com_custom." + name.toLowerCase() === facet.key.toLowerCase()) {
        resultFacet = facet;
      }
    } else if (facet.$type === "Relewise.Client.DataTypes.Search.Facets.Result.PriceRangeFacetResult, Relewise.Client") {
      if (name.toLowerCase() === 'salesprice') {
        resultFacet = facet;
      }
    }
  });
  return resultFacet;
}

export function getQuery(value) {
  return value.trim();
}

export function sortVariants(allVariants) {
  if (!allVariants) return [];
  return allVariants.sort((a, b) => {
    const sizeOrder = ['XXXS', '3XS', 'XXS', '2XS', 'XS', '1XS', 'S', 'M', 'L', 'XL', '1XL', 'XXL', '2XL', 'XXXL', '3XL', 'XXXXL', '4XL', 'XXXXXL', '5XL', 'XXXXXXL', '6XL'];
    const aIndex = sizeOrder.indexOf(a.displayName);
    const bIndex = sizeOrder.indexOf(b.displayName);

    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    } else if (aIndex !== -1) {
      return -1;
    } else if (bIndex !== -1) {
      return 1;
    } else {
      return a.displayName.localeCompare(b.displayName, undefined, { numeric: true });
    }
  });
}

export async function getUser() {
  return new Promise((resolve) => {
    const checkInterval = 50;
    const maxAttempts = 40; // 2 seconds max
    let attempts = 0;

    const check = () => {
      try {
        if (
          RelewiseWebComponents &&
          typeof RelewiseWebComponents.getRelewiseUIOptions === "function" &&
          RelewiseWebComponents.getRelewiseUIOptions().contextSettings &&
          typeof RelewiseWebComponents.getRelewiseUIOptions().contextSettings.getUser === "function"
        ) {
          const user = RelewiseWebComponents.getRelewiseUIOptions().contextSettings.getUser();
          if (user && Object.prototype.hasOwnProperty.call(user, 'temporaryId')) {
            resolve(user);
          } else if (attempts < maxAttempts) {
            attempts++;
            setTimeout(check, checkInterval);
          } else {
            resolve(null);
          }
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(check, checkInterval);
        } else {
          resolve(null);
        }
      } catch (error) {
        if (attempts < maxAttempts) {
          attempts++;
          setTimeout(check, checkInterval);
        } else {
          resolve(null);
        }
      }
    };

    check();
  });
}